import React, { FC } from 'react';
import { Button, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const ButtonTab = styled(Button)(({ theme }) => ({
  ['&.MuiButton-textPrimary']: {
    borderBottom: '4px solid',
    borderRadius: 0,
    fontWeight: 500,
    paddingBottom: 2,
  },
  ['&.MuiButton-containedSecondary:hover']: {
    backgroundColor: theme.palette.secondary.main,
  },
  ['&:hover']: {
    backgroundColor: 'transparent',
  },
}));

interface Props {
  value: any;
  label: string;
  onClick?: (value: any) => void;
  active?: boolean;
  className?: string;
}

export const Tab: FC<Props> = ({ label, value, onClick, active, className }) => {
  const theme = useTheme();

  const handleClick = () => {
    if (!onClick) {
      return;
    }

    onClick(value);
  };

  return (
    <ButtonTab className={className} variant="text" color={active ? 'primary' : 'inherit'} onClick={handleClick}>
      <Typography fontSize="inherit" component="span" sx={{ color: active ? undefined : theme.palette.text.secondary }}>
        {label}
      </Typography>
    </ButtonTab>
  );
};
